import { createDiv, createDom, makeClickable, removeDom } from "../domUtils.mjs";
import createError from "./createError.mjs";
const open = function() {
  return new Promise(function(resolve, reject) {
    const overlay = createDiv("devkit-instant-mock-overlay");
    const container = createDiv("devkit-instant-mock-matchmakingInfo", overlay);
    const box = createDiv("devkit-instant-mock-matchmakingInfo-box", container);
    const closeButton = createDiv("devkit-instant-mock-closeBtn", box);
    createDom("h1", void 0, box).innerText = "Challenge Others to Play";
    createDom("p", void 0, box).innerText = "Messenger will add you to a group chat with other players so you can connect and play games together. It may take a few moments to find other players so you can close Messenger while you wait.";
    createDom("p", void 0, box).innerText = "Your name and profile picture will be displayed. You can leave the group chat at any time. Ready, set, game on!";
    const button = createDiv("devkit-instant-mock-matchmakingInfo-btn", box);
    button.innerText = "Challenge Others";
    makeClickable(closeButton, () => {
      removeDom(overlay);
      reject(createError("USER_INPUT"));
    });
    makeClickable(button, () => {
      removeDom(overlay);
      resolve();
    });
  });
};
const matchmakingInfo = { open };
export {
  matchmakingInfo as default
};
